module.exports = __webpack_public_path__ + "img/calendar-minus-02.b77f4298.svg";